
  import { Vue, Component } from 'vue-property-decorator';

  @Component
  export default class McMealCardTests extends Vue {
    created() {
    }

    mounted() {
    }
  }
